import React, {Dispatch, SetStateAction, useMemo, useState,} from "react";
import {SETable} from "../../../../../../../../../../components/SETable";
import {Grid} from "@mui/material";
import {TabButton, TabsWrapper} from "../styles";
import {SEText} from "../../../../../../../../../../components/SEText";
import {AtendimentosSSEService} from "../../../../../../../services";
import useAbortableRequest from "../../../../../../../../../../../hooks/useAbortableRequest";
import {removeEmpty, removeEmptyProperties,} from "../../../../../../../../../../utils/utils";
import {useQuery} from "react-query";
import moment from "moment";
import SEInputSearch from "../../../../../../../../../../components/SEInputSearch";
import {SEButtonExport} from "../../../../../../../../../../components/SEButtonExport";
import {Filters} from "../../../../Filters";
import {formatDateToBR, formatHoursToBRWithoutSeconds,} from "../../../../../../../../../../../utils/time";
import {formatCPF} from "../../../../../../../../../../../utils/utils";
import {cnpjMask, formatDefaultValueSelect,} from "../../../../../../../../../../../utils/mask";
import {VISITA_LABEL} from "../DescartadosTable";
import {TableFilters} from "../../Filters";
import {tableColumnsGerencial} from "../GerencialTable/columns";
import AttachmentDialog from "../../AttachmentDialog";
import SignatureDialog from "../../SignatureDialog";
import ImageDialog from "../../ImageDialog";
import ModalDevolutiva from "../../ModalDevolutiva";
import ModalOrientacao from "../../ModalOrientacao";
import ModalAnotacao from "../../ModalAnotacao";
import ModalJustificativaMapa from "../../ModalJustificativaMapa";
import {useHistory} from "react-router";
import {useReportsFilter} from "../../../../../../../../../../../context/ReportsFilterContext";
import useExcelExport from "../../../../../../../../../../hooks/useExcelExport";

interface Props {
  tabSelected: string;
  setTabSelected: Dispatch<SetStateAction<string>>;
  tabs: string[];
}

const TestadoresTable = ({ tabSelected, setTabSelected, tabs }: Props) => {
  const history = useHistory();
  const [searchText, setSearchText] = useState<string | null>(null);
  const { createAbortController } = useAbortableRequest();

  const {
    paginationFilters,
    bodyFilters,
    handleSearchChange,
    handlePageChange,
    handleChangeOrder,
    handleLinesPerPage,
    handleChangeBodyFilter,
    setPaginationFilters,
  } = useReportsFilter();

  const [modalDevolutiva, setModalDevolutiva] = useState({
    open: false,
    data: {},
  });

  const [modalAnotacao, setModalAnotacao] = useState({
    open: false,
    data: {},
  });

  const [modalOrientacao, setModalOrientacao] = useState({
    open: false,
    data: {},
  });

  const [modalJustificativa, setModalJustificativa] = useState({
    open: false,
    data: {},
  });

  const [modalImages, setModalImages] = useState({
    open: false,
    data: {},
  });

  const [modalSignature, setModalSignature] = useState({
    open: false,
    data: {},
  });

  const [modalAttachment, setModalAttachment] = useState({
    open: false,
    data: {},
  });

  const bodyParams = removeEmptyProperties({
    ...bodyFilters,
    oqueVoceProcura: searchText,
    treinamento: true,
    tipoPessoa: "TODAS",
    tipoAtendimento: "AGENTE_SSE",
  });

  const { data, isLoading: isLoadingPorTestadores } = useQuery({
    queryFn: () =>
      AtendimentosSSEService.findAllTreinamento(
        paginationFilters,
        bodyParams,
        createAbortController()
      ),
    enabled: tabSelected === "Testadores",
    queryKey: [
      "abaPorTestadoresData",
      paginationFilters,
      bodyFilters,
      bodyParams,
    ],
  });

  const filename = `Exportacao_Testador_${moment().format("DD-MM-YYYY")}`;


  const getDataExcelPorTestadores = async () => {
    const bodyParams = removeEmpty({
      ...bodyFilters,
      oqueVoceProcura: searchText,
      tipoPessoa: "TODAS",
      tipoAtendimento: "AGENTE_SSE",
    });

    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 2000 };
    const response = await AtendimentosSSEService.findAllTreinamento(
      pageFilter,
      bodyParams
    );

    return response?.content?.map((r: any) => ({
      COD: r?.id,
      DATA: formatDateToBR(r?.dataAtendimento),
      HORA: formatHoursToBRWithoutSeconds(r?.dataAtendimento),
      CPF: r?.administrador?.cpf ? formatCPF(r?.administrador?.cpf) : "",
      CNPJ: r?.empreendedor?.cnpj ? cnpjMask(r?.empreendedor?.cnpj) : "",
      PORTE:
        r?.empreendedor?.dadoComplementar?.porte?.sigla ??
        r?.empreendedor?.porteApp?.sigla ??
        "",
      UF: r?.empreendedor?.uf,
      CIDADE: r?.empreendedor?.cidade?.nome,
      AGENTE: r?.nomeAtendente,
      INTERACAO: r?.tipoInteracao
        ? formatDefaultValueSelect(r?.tipoInteracao)
        : "",
      VISITA:
        r?.visita && r?.visita in VISITA_LABEL
          ? VISITA_LABEL[r.visita as keyof typeof VISITA_LABEL]
          : "",
    }));
  };

  const { executeDownload, downloading } = useExcelExport({
    handleDataCallback: getDataExcelPorTestadores,
    filename: filename,
    colorLoading: "#3498db",
    isCsv: false,
  });

  const handleRedirectToRegistroSas = (cpf: string) => {
    if (cpf) {
      const url = `/reports/RegistroSas?cpf=${cpf}`;
      history.push(url);
    }
  };

  const memoizedColumns = useMemo(
    () =>
      tableColumnsGerencial({
        setModalAnotacao,
        setModalOrientacao,
        setModalAttachment,
        setModalImages,
        setModalSignature,
        setModalDevolutiva,
        handleRedirectToRegistroSas,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <Filters onClearFilters={() => setSearchText(null)} />
      <SETable
        columns={memoizedColumns}
        data={data?.content}
        isLoading={isLoadingPorTestadores}
        page={paginationFilters.page}
        direction={paginationFilters?.direction === "ASC" ? "DESC" : "ASC"}
        orderBy={paginationFilters?.orderBy}
        totalPages={data?.totalPages}
        linesPerPageFilters={paginationFilters.linesPerPage}
        onOrderChange={handleChangeOrder}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        onLinesPerPageChange={handleLinesPerPage}
        tableHeader={
          <Grid container paddingBottom={2} gap={2}>
            <Grid item container md={12} justifyContent={"space-between"}>
              <Grid item>
                <TabsWrapper>
                  {tabs.map((tab, index) => (
                    <TabButton
                      key={tab}
                      isActive={tabSelected === tab}
                      index={index}
                      onClick={() => setTabSelected(tab)}
                    >
                      <SEText>{tab}</SEText>
                    </TabButton>
                  ))}
                </TabsWrapper>
              </Grid>
              <Grid item>
                <TableFilters
                  filters={bodyFilters}
                  setFilters={handleChangeBodyFilter}
                  setPaginationFilters={setPaginationFilters}
                />
              </Grid>
            </Grid>
            <Grid
              justifyContent={"space-between"}
              alignItems={"center"}
              direction={"row"}
              container
            >
              <Grid item>
                <SEInputSearch
                  placeholder="Digite o que você procura"
                  value={searchText ?? ""}
                  onClick={() => handleSearchChange(searchText)}
                  onChange={(e) => setSearchText(e?.target?.value)}
                />
              </Grid>

              <Grid
                item
                display={"flex"}
                direction={"row"}
                alignItems={"center"}
              >
                <Grid item mr={2}>
                  {!!data?.totalElements && (
                    <SEText as="p" font="Mulish">
                      Mostrando <strong>{data?.totalElements}</strong>{" "}
                      {data?.totalElements === 1 ? "resultado" : "resultados"}
                    </SEText>
                  )}
                </Grid>

                <Grid item>
                  <SEButtonExport
                    isLoading={downloading}
                    onClick={executeDownload}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      />

      {!!modalJustificativa?.open && (
        <ModalJustificativaMapa
          data={modalJustificativa.data}
          open={modalJustificativa?.open}
          onClose={() => setModalJustificativa({ open: false, data: {} })}
        />
      )}
      {!!modalAnotacao?.open && (
        <ModalAnotacao
          data={modalAnotacao.data}
          open={modalAnotacao?.open}
          onClose={() => setModalAnotacao({ open: false, data: {} })}
        />
      )}
      {!!modalOrientacao?.open && (
        <ModalOrientacao
          data={modalOrientacao.data}
          open={modalOrientacao?.open}
          onClose={() => setModalOrientacao({ open: false, data: {} })}
        />
      )}
      {!!modalDevolutiva?.open && (
        <ModalDevolutiva
          data={modalDevolutiva.data}
          open={modalDevolutiva?.open}
          onClose={() => setModalDevolutiva({ open: false, data: {} })}
        />
      )}
      {!!modalImages?.open && (
        <ImageDialog
          data={modalImages.data}
          open={modalImages?.open}
          onClose={() => setModalImages({ open: false, data: {} })}
        />
      )}
      {!!modalSignature?.open && (
        <SignatureDialog
          data={modalSignature.data}
          open={modalSignature?.open}
          onClose={() => setModalSignature({ open: false, data: {} })}
        />
      )}
      {!!modalAttachment?.open && (
        <AttachmentDialog
          data={modalAttachment.data}
          open={modalAttachment?.open}
          onClose={() => setModalAttachment({ open: false, data: {} })}
        />
      )}
    </>
  );
};

export default TestadoresTable;
